export class GameEvent {
    protected readonly _properties: any;

    constructor(protected _type: string, _properties: any = {}) {
        this._properties = _properties;
    }

    get properties() {
        return this._properties;
    }
    get type() {
        return this._type;
    }
}